import { useQuery } from '@tanstack/react-query';

import { uiDefinitionsQueryKeys } from '@/domains/ui-definitions';

export const useUIDefinitionsQuery = () => {
  const { isLoading, data } = useQuery({
    ...uiDefinitionsQueryKeys.list(),
    // @ts-ignore
    retry: false,
    keepPreviousData: true,
  });

  return {
    isLoading,
    data,
  };
};
